import React from 'react'
import styled from '@emotion/styled'
import { Alert } from '@retailer-platform/shared-components'
import { Flipper } from 'legacy/contexts/flipper/FlipperContext'
import useAccessControl from 'legacy/components/AccessControl/useAccessControl'
import { useGoToRetailerCollections } from 'domains/retailer-collections'

const Link = styled.a({
  cursor: 'pointer',
  textDecoration: 'underline',
})

export const DeprecationBanner = () => {
  const hasAccess = useAccessControl()
  const retailerCollectionsEnabled = hasAccess({
    warehouseFlippers: [Flipper.RetailerCollections],
  })
  const goToRetailerCollectons = useGoToRetailerCollections()

  return (
    retailerCollectionsEnabled && (
      <Alert variant="warning" css={{ flexDirection: 'row', justifyContent: 'flex-start' }}>
        <div>
          You are migrated over to{' '}
          <Link onClick={() => goToRetailerCollectons()}>Retailer Collections</Link>. Please do not
          create custom D&A.{' '}
        </div>
      </Alert>
    )
  )
}
